/**
 * TimedExecutor
 *
 * Execute function within defined intervals
 * `run` function will receive promise, iterations will continue on its resolve.
 * `timeout` can be a number or an array of numbers,
 * `condition` boolean condition to start executor at the time of initialization
 * `params` if defined while initializing will be passed to run function after the promise
 * if iteration count exceeds number of defined timeouts - last array value will be used
 *
 * <example>
 var timedExecutor = new app.namespace.Model.TimedExecutor({
    timeout: [1, 2, 3],
    run: exe.bind(this)
}, {
    params: ['arg1', 'arg2'],
    condition: true
});
 function exe (loop, arg1, arg2) {
    console.debug('thank you', arguments);
    loop.resolve();  // resolve to continue the loop
}
 * </example>
 */
import app from 'app';

app.namespace.Model.TimedExecutor = Backbone.Model.extend({
  '?': 'TimedExecutor',

  defaults: {
    timeout: null,
    run: null,
    kill: null,
    _timer: null,
    _terminated: false,
  },

  initialize: function (raw, options) {
    this.options = $.extend(
      {
        params: [],
      },
      options
    );

    this.startIf(this.options.condition);
  },

  startIf: function (condition) {
    condition && this.start();
  },

  start: function () {
    if (this.isRunning()) {
      this.stop();
    }

    this.set({
      _timer: null,
      _terminated: false,
    });
    if (
      _.isFunction(this.get('run')) &&
      ((_.isArray(this.get('timeout')) && !_.isEmpty(this.get('timeout'))) ||
        _.isNumber(this.get('timeout')))
    ) {
      this._startTimer();
      if (
        _.isObject(this.get('kill')) &&
        _.isNumber(this.get('kill').timeout)
      ) {
        this.set('_killStart', new Date());
      }
    }
  },

  stop: function () {
    if (this.get('_timer')) {
      window.clearTimeout(this.get('_timer'));
      this.set('_timer', null);
    }
    this.set('_terminated', true);
  },

  isRunning: function () {
    return null !== this.get('_timer');
  },

  _getTimeout: function () {
    let rv;
    if (_.isArray(this.get('timeout'))) {
      rv = this.get('timeout').shift();
      if (_.isEmpty(this.get('timeout'))) {
        // transform emptied array into his last single value
        this.set('timeout', rv);
      }
    } else if (_.isNumber(this.get('timeout'))) {
      rv = this.get('timeout');
    }

    return rv * 1e3;
  },

  _startTimer: function () {
    if (!this.get('_terminated')) {
      this.set(
        '_timer',
        window.setTimeout(this._onTimer.bind(this), this._getTimeout())
      );
    }
  },

  _onTimer: function () {
    if (this.get('_killStart')) {
      const now = new Date();
      if ((now - this.get('_killStart')) / 1000 >= this.get('kill').timeout) {
        this._kill();
        return;
      }
    }
    const promise = $.Deferred();
    // eslint-disable-next-line prefer-spread
    this.get('run').apply(null, [promise].concat(this.options.params));
    promise.done(this._startTimer.bind(this)).fail(this.stop.bind(this));
  },

  _kill: function () {
    if (this.isRunning()) {
      this.stop();
      if (_.isFunction(this.get('kill').run)) {
        this.get('kill').run();
      }
    }
  },
});
